<template>
  <div class="header-menu__item" @click="$emit('onMenuItemClicked', index)" v-if="isVisible">
    {{ title }} 
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String, 
      default: ''
    },
    index: {
      type: Number
    },
    isVisible: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style lang="scss" scoped>
  .header-menu__item {
    font-size: 10pt;
    font-weight: bold;
    color: white;
    margin-right: 8px;
    text-transform: uppercase;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 10px;

    &.active {
      background-color: white;
      color: black;
    }

    &:hover {
      cursor: pointer;
    }
  }


</style>